import { isValidPhone } from './formValidation';
import options from '../content/intakeOptions.json';

export const emptyIntake = () => ({ contactName: '', defendantName: '', contactPhone: '', contactEmail: '', relationship: '', caseRegion: '', inCustody: '', detentionFacility: '', bailStatus: '', bailAmount: '', arrestingAgency: '', targetCourt: '', nextCourtDate: '', noCourtDate: false, primaryCharge: '', documentsReady: [], additionalInfo: '', company: '' });

export function validateCourtDate(value) {
  if (!value) return '';
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return 'Please enter a valid court date.';
  const date = new Date(`${value}T00:00:00.000Z`);
  return Number.isNaN(date.getTime()) || date.getUTCFullYear() < 1 || date.toISOString().slice(0, 10) !== value ? 'Please enter a valid court date.' : '';
}

const includes = (choices, value) => choices.some(([key]) => key === value);

function validateBailAmount(values) {
  if (values.bailStatus !== 'set' || !values.bailAmount) return '';
  return !/^\d+(\.\d{1,2})?$/.test(values.bailAmount) || Number(values.bailAmount) > 9999999999
    ? 'Enter a valid dollar amount with up to two decimal places, or leave blank.' : '';
}

const validators = {
  contactName: values => values.contactName.trim() ? '' : 'Please enter your full legal name.',
  defendantName: values => values.defendantName.trim() ? '' : 'Please enter the defendant’s full legal name.',
  contactPhone: values => isValidPhone(values.contactPhone) ? '' : 'Please enter a valid phone number with 10 to 15 digits.',
  contactEmail: values => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.contactEmail.trim()) ? '' : 'Please enter a valid email address.',
  relationship: values => includes(options.relationships, values.relationship) ? '' : 'Please select your relationship to the defendant.',
  caseRegion: values => options.regions.some(region => region.value === values.caseRegion) ? '' : 'Please select the case region.',
  inCustody: values => ['yes', 'no'].includes(values.inCustody) ? '' : 'Please select Yes or No.',
  bailAmount: validateBailAmount,
  nextCourtDate: values => values.noCourtDate ? '' : validateCourtDate(values.nextCourtDate),
};

export function validateIntake(values) {
  return Object.fromEntries(Object.entries(validators).map(([field, validate]) => [field, validate(values)]).filter(([, error]) => Boolean(error)));
}